import dayjs, { Dayjs } from "dayjs";

export class PrestaDataDigit {
    noEmployeur: number = 0;
    noTravailleur: number = 0;
  }

  export class PrestaDataCrypted {
    noEmployeur: string = "";
    noTravailleur: string = "";
  }
  
  export class PrestaEmployerAccess {
    utilisateur: string = "";
    noEmployeur: number = 0;
  }
  
  export class CheckWorkerValid {
    noEmployeur: number = 0;
    noTravailleur: number = 0;

  }

  export class Cl_PrestaEmployerAccess
  {
      accessOk : boolean = false;
      denomination : string = "";
  }

  export class Cl_PrestaEmployeeAccess
  {
    accessOk : boolean = false;
    employeeContract : Cl_TravailleurValide = new Cl_TravailleurValide();
  }

  export class Cl_TravailleurValide
  {
      Nom : string = "";
      Prenom : string = "";
      ContratValide : boolean = false;
  }

  export class Cl_PrestaImport
  {
      employerAccessOk : boolean = false;
      employeeAccessOk : boolean = false;
      dataImportOk : boolean = false;
      prestaData : ClDonneesPresta = new ClDonneesPresta();
  }

export class ClDonneesPresta
    {
        NoEmployeur : number = 0;
        NoContrat : number = 0;
        Nom : string = "";
        Prenom : string = "";
        DateNaissance : Dayjs = dayjs();
        CdEtatCivil : number = 0;
        CdTravailleurHandicape : number = 0;
        CdConjointACharge : number = 0;
        CdConjointHandicape : number = 0;
        NbEnfantACharge : number = 0;
        NbEnfantAChargeHandicape : number = 0;
        NbPersonneMoins65ACharge : number = 0;
        NbPersonneMoins65AChargeHandicape : number = 0;
        NbPersonnePlus65ACharge : number = 0;
        NbPersonnePlus65AChargeHandicape : number = 0;

        PrecisionCategorieContrat : number = 0;
        CategorieOnss : number = 0;
        CategorieContrat : number = 0;
        NoComParitaire : string = "";
        PrefixeOnss : string = "";
        CdTempsPleinPartiel : number = 0;
        CdSoumisOnss : number = 0;
        CdSoumisPrecompte : number = 0;
        MontantBaseRemuneration : number = 0;

        CdImportanceActuel : number = 0;
        UniteEtablissement : string = "";
        CdBaseRemuneration : number = 0;
        CdPersonnel : number = 0;
        Regime : ClRegime = new ClRegime();
        EltRegime : Array<CdEltRegime> = new Array<CdEltRegime>();
        EltRegimeEmployeur : Array<CdEltRegime> = new Array<CdEltRegime>();
    }

export class ClRegime
{
    CdRegime : string = "";
    DureeJours : number = 0;
    TotalHeures : number = 0;
}

export class CdEltRegime
{
    NoJour : number = 0;
    DureeMinute : number = 0;
    CdPrestEquipe1 : string = "";
}

export class AuthGS
{
  UserName : string = "";
  Domain : string = "";
  IsAuth : boolean = false;
}